import { render } from 'react-dom'
import './styles.css'
import * as THREE from 'three'
import { useRef, Suspense } from 'react'
import { Canvas, useFrame } from '@react-three/fiber'
import { Center, Bounds, OrbitControls, Instances, Instance } from '@react-three/drei'
import * as Tone from 'tone'
import Colors from './Colors'
require('./path')

let randI = (i) => Math.floor(i * fxrand())
let rand = (arr) => arr[randI(arr.length)]
const ci = randI(Colors.length)

const cols = Colors[ci]
const bgColor = cols.shift()

function shuffle(array) {
  let currentIndex = array.length, randomIndex;
  while (currentIndex != 0) {
    randomIndex = Math.floor(fxrand() * currentIndex);
    currentIndex--;
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex], array[currentIndex]];
  }
  return array;
}
shuffle(cols)

let started = false
Tone.Transport.bpm.value = rand([111, 122, 133, 144, 155])

export default function App() {
  const click = () => {

    if (!started) {
      started = true
      genNotes()
      Tone.start();
      Tone.Transport.start();
      part.stop()
      part.start('+0.01')
      timeouts.forEach((t, i) => clearTimeout(t))
      animate = true;
      rowsAnimated = dimension + zz - 1
      count = -1
      mode = randI(modes.length)
    } else {
      dir = !dir
      started = false
      animate = false;
      part.stop()
      new Array((dimension + (zz))).fill().map((_, i) => {
        let d = ((0.003 * i)) * (0.1 + (i * (40 / zz)))
        timeouts[i] = setTimeout(() => {
          insts[notes[notes.length - 1]].triggerAttackRelease(rand(['C3']), d * rand([0.8, 0.9, 1, 0.7]) * 0.02, '+0', 0.65 + (randI(2) * 0.05));
          insts[notes[notes.length - 2]].triggerAttackRelease(rand(['C3']), d * rand([0.8, 0.9, 1, 0.7]) * 0.02, '+0', 0.65 + (randI(2) * 0.05));
          rowsAnimated -= 1;
        }, d * 1000)
      })
    }

  }
  let timeouts = []
  let z = 0.1 * dimension
  return (
    <div id="main"
      onClick={() => click()}
    >
      <Canvas flat={true} dpr={[1, 2]} camera={{ near: 0.0001, far: 10, position: [rand([z, -z]), rand([z, -z]) * 0.8, z * 1], fov: 0.1 }}>
        <Stuff />
        <Back />
        <ambientLight intensity={0.8} />
        <directionalLight position={[10, 10, 0]} intensity={0.75} />
        <directionalLight position={[-10, 10, 5]} intensity={0.5} />
        <directionalLight position={[-10, 20, 0]} intensity={0.75} />
        <directionalLight position={[0, -10, 0]} intensity={0.65} />
        <OrbitControls maxDistance={1} />
      </Canvas>
    </div>
  )
}
function Stuff() {
  return (
    <Bounds fit margin={1.5 + ((dimension * 0.08))} damping={0}>
      <Center>
        <group rotation={[Math.PI * rand([0, 0, 0, 0,0,0,0.5]), 0, 0]}>
          <Screens />
        </group>
      </Center>
    </Bounds>
  )
}

let dimension = rand([2, 2, 3, 3, 3, 3, 3, 3, 4, 5])
let paths = window.hampath.generate({
  width: dimension * rand([1]),
  height: dimension * rand([1]),
})
let melodyLen = paths.data.length - 1

window.$fxhashFeatures = {
  bpm: Tone.Transport.bpm.value,
  dimension,
}

let sc = 0.0000015
let geo = new THREE.BoxBufferGeometry(sc, sc, sc * 0.5)
let zz = Math.ceil(6 + randI(44) / (dimension * 0.4))
function Screens() {
  return (
    <Instances limit={100000} geometry={geo}>
      <meshBasicMaterial depthTest={false} color={'white'} />
      {new Array(dimension).fill().map((_, x) =>
        <group key={x}>
          {new Array(dimension).fill().map((__, y) =>
            <group key={y}>
              {new Array(Math.ceil((dimension + (zz)))).fill().map((__, z) =>
                <group key={z} >
                  <Line i={(x * dimension) + y} z={z} />
                </group>
              )}
            </group>
          )}
        </group>
      )}
    </Instances>
  )
}

let s = 0.0002
let zScale = rand([0.02, 0.04, 0.06])
let getX = (x) => (((dimension - 1) * -0.5) * s) + (x * s)
let getY = (y) => (((dimension - 1) * -0.5) * s) + (y * s)
let getZ = (z) => (z * s * zScale)

let width = 134
let widthMult = rand([1, 1, 1, 1, 1, 1, 1, 1, 1])
let div = width * widthMult
let colMods = rand([4, 8, 10, 11, 12, 14, 16, 20, 24])
let colInf = rand([1, 2, 0.5, 0.25, 0.125])
let animate = false;
let colAdd = 1 + randI(3)
let dir = true
function Line({ i, z }) {
  const ref = useRef();
  let p0 = paths.data[i]
  let p1 = paths.data[(i + 1) % paths.data.length]
  let x = (p0[0] - p1[0])
  let y = (p0[1] - p1[1])
  let sx = 1 + (x * div)
  let sy = (sx !== 1) ? 1 : (1 + (y * div))
  useFrame((state) => {
    if (((count % melodyLen) === i) && animate) {
      let m1 = Math.abs((modes[mode](state.clock.getElapsedTime() * (0.016 * Tone.Transport.bpm.value), z, p0[0])))
      let m2 = Math.abs((modes[mode](state.clock.getElapsedTime() * (0.016 * Tone.Transport.bpm.value), z, p0[1])))
      ref.current.scale.x = m1
      ref.current.scale.y = m2
    } else if ((dir ? (dimension + (zz - 1) - z) : z) > rowsAnimated) {
      ref.current.scale.x = 1
      ref.current.scale.y = 1
    } else if (((count % melodyLen) === i)) {
      let m1 = Math.abs((modes[mode](state.clock.getElapsedTime() * (0.016 * Tone.Transport.bpm.value), z, p0[0])))
      let m2 = Math.abs((modes[mode](state.clock.getElapsedTime() * (0.016 * Tone.Transport.bpm.value), z, p0[1])))
      ref.current.scale.x = m1
      ref.current.scale.y = m2
    }
  })
  let ci = (Math.floor((i + z) / 3) % 9) ?
    ((Math.floor(((i * colInf) + (z)) / (colMods * (i)))) % cols.length) :
    ((Math.floor(((i * colInf) + (z)) / (colMods * (i))) + colAdd) % cols.length)
  return (
    <group ref={ref}>
      {i !== (paths.data.length - 1) && <Instance
        color={cols[ci]}
        position={[getX(p0[0] - (x * 0.5)), getY(p0[1] - (y * 0.5)), getZ(z)]}
        scale={[sx, sy, 1]} />}
    </group>
  )
}
let ready = false

function Back() {
  const ref = useRef();
  useFrame((state) => {
    if (state.clock.getElapsedTime() > 1) {
      // ref.current.scale.setScalar(0)
    }
  })
  return (
    <group ref={ref}>
      <mesh>
        <meshBasicMaterial color={bgColor} side={THREE.BackSide} />
        <octahedronBufferGeometry args={[40, 3]} />
      </mesh>
    </group>
  )
}
document.getElementById('root').style.background = bgColor
render(
  <>
    <Suspense fallback={null}>
      <App />
    </Suspense>
  </>,
  document.getElementById('root')
)

let filters = []
let pans = []
const instNotes = ['G2', 'A2', 'C3', 'D3', 'E3', 'A3', 'G3']
let pansAmt = instNotes.length
let spread = 1.9
new Array(pansAmt).fill().map((_, i) => {
  pans[i] = new Tone.Panner((((spread / pansAmt) * i) - (spread * 0.5)) + (spread / (pansAmt * 2))).toDestination()
  filters[i] = new Tone.Filter(2200 + (10 * randI(10)), "bandpass", -12).connect(pans[i])
  filters[i].connect(pans[randI(pans.length)])
})

const insts = {};
instNotes.forEach((n, i) => {
  insts[n] = new Tone.Sampler({ urls: { C3: "./teropa/scale-" + n + ".mp3" } })
  insts[n].attack = (1 + randI(4)) * 0.02
  insts[n].release = 10
  insts[n].volume.value = 6
  insts[n].connect(filters[i])
})
let posMod = rand([12])

let last = ''
let notes = []
let genNotes = () => {
  notes = new Array(melodyLen).fill().map((_, i) => {
    let note = rand(Object.keys(insts))
    if (note === last) {
      note = rand(Object.keys(insts))
    }
    last = note
    return note
  })
}
genNotes()
let modes = [
  (t, c, r) => ((c + (r + t * 10) ^ c - (r + t * 10)) % 11 & 1) - .1,
  (t, c, r) => ((c + (r + t * 10) ^ c - (r + t * 10)) % 11 & 1) - .1,
  (t, c, r) => ((c + (r + t * 9) ^ c - (r + t * 9)) % 17 & 1) - .1,
  (t, c, r) => ((c + (r + t * 9) ^ c - (r + t * 9)) % 17 & 1) - .1,
  (t, c, r) => ((c + (r + t * 9) ^ c - (r + t * 9)) % 13 & 1) - .15,
  (t, c, r) => ((c + (r + t * 9) ^ c - (r + t * 9)) % 13 & 1) - .15,
  (t, c, r) => Math.max(0, Math.sin(r ^ ((c * (t * 0.1)) + 6 * t))),
  (t, c, r) => Math.max(0, Math.sin(r ^ ((c * (t * 0.1)) + 6 * t))),
]
let mode = randI(modes.length)
let count = -1
let durs = ['8n']

let time = 0;
let dur = 0;
let phase = new Array(melodyLen).fill().map((_, i) => {
  let dur = Tone.Time(rand(durs)).toSeconds()
  let note = rand(instNotes)
  let vel = 1.95 + (randI(4) * 0.06)
  let res = {
    time,
    dur,
    i,
    note,
    vel,
  }
  time = time + dur
  return res
})

let part = new Tone.Part(((time, { dur, vel, i }) => {
  count++;
  if ((count % (melodyLen * 8)) > (melodyLen * 7.5)) {
    oct = 1
    mode = randI(modes.length)
    if (randI(100) > 90) {
      notes[randI(notes.length)] = rand(Object.keys(insts))
    }
  } else {
    oct = 0
  }
  let note = notes[i]
  insts[note].triggerAttackRelease('C' + (2 + oct), (dur * 0.1) / (1 + oct), time, (vel * 0.8) / (1 + (oct * 2)));
  if (randI(100) > 95) {
    let randNote = rand(instNotes)
    insts[randNote].triggerAttackRelease('C' + (3), dur * 0.03, time, vel * 0.4);
  }

  if (randI(100) > 95) {
    let randNote = rand(instNotes)
    insts[randNote].triggerAttackRelease('C' + (1), dur * 1.2, time, vel * 1.5);
  }
  if (randI(100) > 96) {
    let randNote = rand(instNotes)
    insts[randNote].triggerAttackRelease('C' + (1), dur * 1.8, time, vel * 1.2);
  }
}), phase)
part.loop = true
part.loopEnd = time + dur
let rowsAnimated = -1
let oct = 0
console.log('%c🐍🐍 @ramioso 2022-05-04 🐍🐍', 'color: green');